import script from "./ProjectTeam.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectTeam.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectTeam.vue?vue&type=style&index=0&id=520afbe4&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-520afbe4"]])

export default __exports__